import { checkGardenerName } from "../../../gardener/helpers/status";
import { keysOf } from "../../../shared-functions/objects";
import { safeToLowerCase } from "../../../shared-functions/string";

export const getCount = (
  resources:
    | { [key: string]: unknown }
    | { [key: string]: unknown }[]
    | undefined,
) => {
  if (Array.isArray(resources)) {
    return resources.length;
  }

  if (resources && typeof resources === "object" && keysOf(resources).length) {
    return 1;
  }

  return 0;
};

export const getPreposition = (operation: string | undefined) => {
  if (!operation) return "";
  const prepositions: Record<string, string> = {
    "enable disaster recovery": " on",
    "disable disaster recovery": " on",
    "disconnect floating ip": " from",
    "remove interface": " from",
    "rotate kubeconfig": " on",
    "trigger maintenance": " on",
    "trigger reconcile": " on",
    "retry last operation": " on",
  };
  return prepositions[safeToLowerCase(operation)] || "";
};

/**
 * Get a list of resources (or a single resource) and spits out the number of resources that are possibly a gardener-created-resource
 * @param {*}   resources  An array of resources or an object {single resource}
 * @param entity
 * @returns a number >= 0
 */
export const getProbableGardenerResources = (
  resources:
    | { [key: string]: unknown }
    | { [key: string]: unknown }[]
    | undefined,
  entity = "",
) => {
  let count = 0;
  if (!resources) return count;

  const resourcesArray = Array.isArray(resources) ? resources : [resources];

  resourcesArray.forEach((resource) => {
    if (entity === "network") {
      const subnets = resource.subnets;
      if (Array.isArray(subnets)) {
        count += getProbableGardenerResources(subnets, entity);
      }
    }

    if (checkGardenerName(resource)) {
      count++;
    }
  });

  return count;
};
